import { createUseStyles } from "react-jss";
import {
    alpha,
    backgroundless,
    borderColor,
    controlBackgroundColor,
    darken,
    foregroundColor,
    getButtonChoiceMargin,
} from "../../theme/Mixins";

export default createUseStyles({
    choice: {
        composes: "choice",
        background: ({ theme, carrouselChoiceBackgound }) =>
            carrouselChoiceBackgound
                ? carrouselChoiceBackgound
                : alpha(theme.ControlBackground, theme.ChoiceListBackgroundAlpha),
        boxShadow: ({ theme }) =>
            `0 0 0 ${theme.ChoiceListBackgroundBorderWidth}px ${theme.ControlBorderColor} inset`,
        borderRadius: ({ theme }) =>
            Math.min(theme.ChoiceListBackgroundBorderRadius, theme.ChoiceHeight / 2),
        boxSizing: "border-box",
        cursor: "pointer",
        display: ({ hasOpenEnd, openEndSize }) =>
            hasOpenEnd && openEndSize === "Full" ? "block" : "flex",
        flexWrap: "wrap",
        margin: ({ theme, horizontal }) => getButtonChoiceMargin(theme, horizontal),
        color: ({ theme }) => foregroundColor(theme, controlBackgroundColor(theme)),
        overflow: "hidden",
        padding: ({ theme }) => (backgroundless(theme) ? [[8, 13]] : [[8, 26]]),
        textAlign: ({ theme }) => (theme.DisplayChoiceIcon === "right" ? "right" : ""),
        transition: "background 200ms, box-shadow 200ms, outline-color 200ms",
        userSelect: "none",
        outline: "2px solid transparent",
        "& .check-box__icon": {
            display: ({ theme }) => (!theme.ShowCheckboxSettings ? "none" : ""),
        },
        "& .radio__icon": {
            display: ({ theme }) => (!theme.ShowRadioSettings ? "none" : ""),
        },
    },
    choiceHeader: {
        composes: "choice__header",
        fontWeight: 700,
        margin: ({ theme }) => [[theme.ChoiceSpacing, 0]],
    },
    choiceText: {
        composes: "choice__text",
        fontWeight: 700,
    },
    choiceContainer: {
        composes: "choice__container",
        alignItems: "center",
        display: "flex",
        flexGrow: 1,
        minWidth: 125,
        flexDirection: ({ theme, type }) =>
            (type === "checkbox" && theme.CheckBoxIconAlignment === "right") ||
            (type === "radio" && theme.RadioIconAlignment === "right")
                ? "row-reverse"
                : "row",
        margin: [[8, 8, 8, 0]],
    },
    choiceSelected: {
        background: ({ theme }) => !backgroundless(theme) && theme.PrimaryColor,
        boxShadow: ({ theme }) =>
            `0 0 0 ${theme.ChoiceListBackgroundBorderWidth}px ${borderColor(
                theme,
                theme.PrimaryColor,
            )} inset`,
        color: ({ theme }) =>
            backgroundless(theme) ? theme.PrimaryColor : foregroundColor(theme, theme.PrimaryColor),
        composes: "choice--selected",
    },
    choiceHover: {
        composes: "choice--hover",
        background: ({ theme, selected }) => {
            if (backgroundless(theme)) {
                return undefined;
            }
            return selected
                ? darken(theme.PrimaryColor, theme.ActiveHighlightValue)
                : darken(theme.ControlBackground, theme.ActiveBackgroundValue);
        },
        color: ({ theme, selected }) => {
            return selected
                ? foregroundColor(theme, darken(theme.PrimaryColor, theme.ActiveHighlightValue))
                : foregroundColor(
                      theme,
                      darken(theme.ControlBackground, theme.ActiveBackgroundValue),
                  );
        },
        boxShadow: ({ theme, selected }) =>
            `0 0 0 ${theme.ChoiceListBackgroundBorderWidth}px ${borderColor(
                theme,
                selected
                    ? darken(theme.PrimaryColor, theme.ActiveHighlightValue)
                    : darken(theme.ControlBackground, theme.ActiveHighlightValue),
            )} inset`,
    },
    choiceActive: {
        composes: "choice--active",
        background: ({ theme, selected }) => {
            if (backgroundless(theme)) {
                return undefined;
            }
            return selected
                ? darken(theme.PrimaryColor, theme.ActiveHighlightValue)
                : darken(theme.ControlBackground, theme.ActiveBackgroundValue);
        },
        color: ({ theme, selected }) => {
            return selected
                ? foregroundColor(theme, darken(theme.PrimaryColor, theme.ActiveHighlightValue))
                : foregroundColor(
                      theme,
                      darken(theme.ControlBackground, theme.ActiveBackgroundValue),
                  );
        },
        outlineColor: ({ theme }) => backgroundless(theme) && theme.PrimaryColor,
    },
    spacer: {
        width: 20,
        flex: 1,
    },
});
